import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {AiFillLinkedin} from 'react-icons/ai';
import {AiFillTwitterSquare} from 'react-icons/ai';
import {AiFillGithub} from 'react-icons/ai'
import("./Contact.css");

export default function Contact() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_fxvhlxh', 'template_bczbjht', form.current, 'aV5J0ror-z4spScPI')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <>
      <div id="contact" className="connect">
        <div>
        <div className="container" id="contact-linkedin">
          <h1 className="con-head">Contact Me</h1>
          <p id="contact-email">
            Drop me a mail at <strong> <a href="mailto:abhishek.jha001996@gmail.com" className="mail-id">abhishek.jha001996@gmail.com</a></strong>
          </p>
          <p id="contact-phone">Phone: +91 8240443100</p>
          
          <div className="links">
            <a
              href="https://github.com/Abhishekjha1996"
              target="_blank"
              rel="noreferrer"
              id="contact-github"
            >
             
              <AiFillGithub className="fontlink"/>
            </a>
            <a
              href="https://www.linkedin.com/in/abhishekjha96/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillLinkedin className="fontlink"/>
              
            </a>
            <a
              href="https://twitter.com/ajha6667/"
              target="_blank"
              rel="noreferrer"
            >
              {/* <i class="fab fa-twitter"></i> */}
              <AiFillTwitterSquare className="fontlink"/>
            </a>
          </div>

          <h4 className="copyright-text">You can clone my website || Made by Abhishek</h4>
        </div>

        </div>

        <div>
        <form ref={form} onSubmit={sendEmail}>
      <label>Name ::</label>
      <input type="text" name="user_name"  placeholder='Enter Name'/><br />
      <label>Email ::</label>
      <input type="email" name="user_email" placeholder='Enter Email' /><br />
      <label>Message ::</label>
      <textarea name="message" /><br/>
      <input type="submit" value="Send" />
    </form>
        </div>

      </div>

    </>
  );
}